import { render, staticRenderFns } from "./_bankDetails.vue?vue&type=template&id=c832837c&scoped=true&lang=pug&"
import script from "./_bankDetails.vue?vue&type=script&lang=js&"
export * from "./_bankDetails.vue?vue&type=script&lang=js&"
import style0 from "./_bankDetails.vue?vue&type=style&index=0&id=c832837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c832837c",
  null
  
)

export default component.exports